module.exports = __webpack_public_path__ + "static/media/user-secret.ccf2871d.svg";